import { HeadingPriority } from "atoms/constants/heading-priority";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Heading from "atoms/typography/heading";
import { siteMap } from "internal-sitemap";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import BookmarkCard from "organisms/my-link/my-bookmarks/bookmark-card";
import React, { useEffect } from "react";
import { RouteUtils } from "utilities/route-utils";
import { useHistory, useLocation, useParams } from "react-router";
import CompactSkipTakeNavigation from "molecules/page-navigation/compact-skip-take-navigation";

const CSS_CLASS_NAME = "c-bookmark-detail-page-sidebar";

export interface BookmarkDetailPageSidebarProps {
    bookmarks?: UserBookmarkRecord[];
    headingText: string;
    headingIcon: Icons;
    additionalHeadingContent?: JSX.Element;
    dropdowns?: JSX.Element;
    isLoading?: boolean;
    onSetPage: (page: number) => void;
    currentPage: number;
    totalPages?: number;
}
const BookmarkDetailPageSidebar = (props: BookmarkDetailPageSidebarProps) => {
    const {
        headingIcon,
        headingText,
        additionalHeadingContent,
        dropdowns,
        bookmarks = [],
        onSetPage,
        currentPage,
        totalPages,
    } = props;
    const {
        group,
        groupId,
        id: selectedBookmarkId,
    } = useParams<{ group: string; groupId: string; id: string }>();
    const { push } = useHistory();
    const { search } = useLocation();

    const handleBookmarkClick = (id) => {
        const routeToDetailPage = RouteUtils.replacePathParams(
            siteMap.myLink.myBookmarks.detail,
            {
                group,
                groupId,
                id,
            }
        );
        push(`${routeToDetailPage}${search}`);
    };

    const selectedBookmarkNode = document.getElementById(selectedBookmarkId);

    useEffect(() => {
        const handleScrollToBookmark = () => {
            selectedBookmarkNode?.scrollIntoView({ behavior: "smooth" });
        };
        if (selectedBookmarkNode) {
            handleScrollToBookmark();
        }
    }, [selectedBookmarkNode]);

    return (
        <aside className={CSS_CLASS_NAME}>
            <header className={`${CSS_CLASS_NAME}__header`}>
                <Icon size={IconSizes.Large} type={headingIcon} />
                <Heading
                    cssClassName={`${CSS_CLASS_NAME}__heading`}
                    priority={HeadingPriority.Three}>
                    {headingText}
                </Heading>
                {additionalHeadingContent}
            </header>
            <nav className={`${CSS_CLASS_NAME}__nav`}>
                {dropdowns}
                <ul className={`${CSS_CLASS_NAME}__list`}>
                    {bookmarks.map((bookmark) => (
                        <li
                            key={bookmark.id}
                            id={bookmark.id!.toString()}
                            className={`${CSS_CLASS_NAME}__listItem ${bookmark.id === Number(selectedBookmarkId) ? "-selected" : ""}`}>
                            <BookmarkCard
                                bookmark={bookmark}
                                collections={[]}
                                inCollectionView={false}
                                onBookmarkDeleted={(bookmark) => {}}
                                onBookmarkUpdated={(bookmark) => {}}
                                onClick={() => handleBookmarkClick(bookmark.id)}
                            />
                        </li>
                    ))}
                </ul>

                {totalPages && totalPages > 1 && (
                    <footer className={`${CSS_CLASS_NAME}__footer`}>
                        <CompactSkipTakeNavigation
                            currentPageNumber={currentPage}
                            setPage={onSetPage}
                            totalPages={totalPages ?? 0}
                        />
                    </footer>
                )}
            </nav>
        </aside>
    );
};

export default BookmarkDetailPageSidebar;
